module.exports = {
  messages: {
    CN: {
      "header.orderManagement": "订单管理",
      "header.pending": "待处理",
      "header.goodsReturn": "退换货",
      "header.commentCheckPending": "评论待审核",
      "header.product": "商品",
      "header.lowStockGoods": "低库存商品",
      "header.logout": "退出登录",
      'header.erpGoods': 'ERP新增商品',
      'header.dyx': '得意先',
      'header.newCount': '新账户待审核'
    },
    JP: {
      "header.orderManagement": "注文管理",
      "header.pending": "待处理",
      "header.goodsReturn": "退换货",
      "header.commentCheckPending": "评论待审核",
      "header.product": "商品",
      "header.lowStockGoods": "低库存商品",
      "header.logout": "ログアウト",
      'header.erpGoods': 'ERP新增商品',
      'header.dyx': '得意先',
      'header.newCount': 'アカウント審査待ち'
    }
  }
};